import { render } from "./DeleteConfirmDialog.vue?vue&type=template&id=6740149a&ts=true"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts"

import "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=6740149a&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__